import { useCheckRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { PageTitle } from '@ospace/layout'
import { createUserSchema } from '@ospace/schemas'
import { ErrorBoundary } from '@ospace/shared'
import React from 'react'
import { useNavigate } from 'react-router'

import { UserForm } from '../components/UserForm'
import { useCreateUserMutation } from '../hooks/useCreateUserMutation'
import { Paper } from '@mantine/core'

export const CreateUserPage: React.FC = () => {
  const navigate = useNavigate()
  const mutation = useCreateUserMutation()

  const initValues = {
    clients: [],
    campaigns: [],
    email: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    userType: undefined,
    avatar: '',
    contactNumber: '',
    region: 'au',
  }

  return (
    <Paper shadow='sm' p='xl' radius='md' m='xl'>
      <h1>Create User</h1>
      <UserForm
        initialValues={{
          ...initValues,
          avatarFile: null as null | File,
        }}
        validationSchema={createUserSchema}
        isSubmitting={mutation.isLoading}
        onSubmit={async (values: any) => {
          await mutation.mutateAsync({
            ...values,
          })
          navigate(`/user`)
        }}
      />
    </Paper>
  )
}

const Controller = () => {
  useCheckRole([userTypes.Admin])
  return <CreateUserPage />
}

export const CreateUserPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
